import { ActionIcon, Flex } from "@mantine/core";
import React, { memo, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, matchPath } from "react-router-dom";
import { ReactComponent as Logo } from "../../../shared/assets/images/logo.svg";
// Temporarily disabled (uncomment to restore):
// import { ReactComponent as InstagramIcon } from "../../../shared/assets/images/instagram.svg";
import { ReactComponent as YoutubeIcon } from "../../../shared/assets/images/youtube.svg";

import styles from "./styles.module.scss";

import { menuItems } from "../../../consts/menuItems";

import clsx from "clsx";
import { modals } from "@mantine/modals";
import LoginButton from "../../../widgets/LoginButton";

import { accountLinks, otherRoles, switchRole, ROLE_NAME } from "../../../components/Header/lib/accountMenu";
import LogoutButton from "../../../widgets/LogoutButton";

const MobileMenuModal = memo(({ innerProps }) => {
  const { pathname } = useLocation();

  const { t } = useTranslation();

  const isCustomAgreementPage = useMemo(() => {
    return !!(
      matchPath(pathname, {
        path: "/submitVideo/:name",
        exact: true,
      }) ||
      matchPath(pathname, {
        path: "/submitVideos/:refHash",
        exact: true,
      })
    );
  }, [pathname]);

  const filteredMenuItems = useMemo(() => {
    return menuItems.filter((el) => {
      if (isCustomAgreementPage) {
        return el.path !== "/submitVideo";
      }

      return el.path !== pathname;
    });
  }, [menuItems, isCustomAgreementPage, pathname]);

  const onClickItem = useCallback(() => {
    modals.closeAll();
  }, [modals]);

  const currentUser = useCallback(innerProps?.currentUser, [innerProps]);
  const setCurrentUser = useCallback(innerProps?.setCurrentUser, [innerProps]);

  return (
    <div className={styles.modal}>
      <Flex
        direction="column"
        align="center"
        gap="xl"
        className={styles.itemsBlock}
      >
        <Link onClick={onClickItem} to="/">
          <Logo className={clsx("logo", styles.logo)} />
        </Link>
        {accountLinks(currentUser, pathname).map((x) => (
          <Link key={x.key} className={clsx([styles.menuItem, styles.colored])} to={x.path} onClick={onClickItem}>
            {x.label}
          </Link>
        ))}
        {otherRoles(currentUser).map((role) => (
          <button
            key={role}
            type="button"
            className={clsx([styles.menuItem, styles.colored, styles.menuButton])}
            onClick={() => {
              modals.closeAll();
              switchRole(role);
            }}
          >
            Switch to {ROLE_NAME[role] || role} role
          </button>
        ))}
        {filteredMenuItems.map(({ label, path }) => (
          <Link
            onClick={onClickItem}
            key={path}
            to={path}
            className={styles.menuItem}
          >
            {t(label)}
          </Link>
        ))}

        {!!currentUser ? (
          <LogoutButton setCurrentUser={setCurrentUser} />
        ) : pathname !== "/login" ? (
          <LoginButton className="widthFull" />
        ) : null}
      </Flex>
      <Flex direction="column" gap="sm" align="center">
        <Link
          to="#"
          onClick={(e) => {
            window.location.href = "mailto:Licensing@vbear.media";
            e.preventDefault();
          }}
        >
          Licensing@vbear.media
        </Link>
        <Flex align="center" gap="sm">
          {/* Instagram temporarily disabled (uncomment to restore):
          <a href="https://www.instagram.com/vbear_media" target="_blank">
            <ActionIcon className={styles.link}>
              <InstagramIcon className={styles.svg} fontSize="large" />
            </ActionIcon>
          </a>
          */}
          <a href="https://www.youtube.com/@vbear_media" target="_blank">
            <ActionIcon className={styles.link}>
              <YoutubeIcon className={styles.svg} fontSize="large" />
            </ActionIcon>
          </a>
        </Flex>
      </Flex>
    </div>
  );
});

export default MobileMenuModal;
